import React from 'react';
import { Link } from 'react-router-dom';
import { Display, Heading, Label } from '../components/Typography';

const Programmes = () => {
  return (
    <div className="w-full min-h-screen bg-epoq-paper pt-12 pb-32">
      <div className="px-6 lg:px-12 max-w-7xl mx-auto mb-24">
        <Label className="text-epoq-coral mb-6 block">Index</Label>
        <Display>Programmes</Display>
      </div>

      <div className="px-6 lg:px-12 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-16">
        
        {/* Available Programmes */}
        <div className="lg:col-span-8">
          <h2 className="font-serif text-3xl italic text-epoq-blue/50 mb-12 border-b border-epoq-blue/20 pb-4">Available first programmes</h2>
          
          <div className="space-y-16">
            <ProgrammeIndexItem 
              num="01"
              title="AI for Leadership and Boards"
              target="Leaders, Board Members, Directors"
              format="1 Day / In-person or Live Online"
              focus="Strategy, Governance, Risk"
              link="/programmes/ai-leadership-boards"
            />
            <ProgrammeIndexItem 
              num="02"
              title="Generative AI for Everyday Knowledge Work"
              target="Professionals, Teams, Specialists"
              format="1 Day / In-person or Live Online"
              focus="Productivity, Quality Control, Workflows"
              link="/programmes/gen-ai-everyday"
            />
          </div>
        </div>

        {/* In Development */}
        <div className="lg:col-span-4">
          <h2 className="font-serif text-3xl italic text-epoq-blue/50 mb-12 border-b border-epoq-blue/20 pb-4">In development</h2>
          
          <div className="space-y-12 opacity-60">
            <div>
              <h3 className="font-serif text-2xl mb-2">Responsible AI, the EU AI Act and Your Company AI Policy</h3>
              <p className="text-sm font-sans mb-4">Focus: Governance & Policy</p>
              <Link to="/contact" className="text-sm underline underline-offset-4 hover:text-epoq-coral">Register interest</Link>
            </div>
            <div>
              <h3 className="font-serif text-2xl mb-2">From AI Experiment to Measurable Business Value</h3>
              <p className="text-sm font-sans mb-4">Focus: Implementation</p>
              <Link to="/contact" className="text-sm underline underline-offset-4 hover:text-epoq-coral">Register interest</Link>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

const ProgrammeIndexItem = ({ num, title, target, format, focus, link }) => (
  <div className="group relative">
    <div className="flex items-baseline gap-4 mb-4">
      <span className="font-serif text-xl text-epoq-coral">{num}</span>
      <Link to={link}>
        <h3 className="font-serif text-4xl lg:text-5xl leading-tight group-hover:text-epoq-coral transition-colors">{title}</h3>
      </Link>
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8 pl-10 border-l border-epoq-blue/10">
      <div>
        <Label className="block mb-1 text-epoq-blue/50 text-[10px]">Target Audience</Label>
        <p className="text-sm">{target}</p>
      </div>
      <div>
        <Label className="block mb-1 text-epoq-blue/50 text-[10px]">Format</Label>
        <p className="text-sm">{format}</p>
      </div>
      <div>
        <Label className="block mb-1 text-epoq-blue/50 text-[10px]">Core Focus</Label>
        <p className="text-sm">{focus}</p>
      </div>
    </div>
    
    <div className="mt-8 pl-10">
      <Link to={link} className="inline-flex items-center gap-2 text-sm font-medium hover:text-epoq-coral transition-colors border-b border-epoq-blue pb-1">
        Read full programme details <span className="transform group-hover:translate-x-1 transition-transform">→</span>
      </Link>
    </div>
  </div>
);

export default Programmes;